import ReactDOM from 'react-dom/client';
import { Shell } from './Shell';

if ('caches' in window) {
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => {
      caches.delete(cacheName).then((_success) => {});
    });
  });
}

if ('serviceWorker' in navigator) {
  window?.addEventListener('load', () => {
    navigator?.serviceWorker?.getRegistrations()?.then((registrations) => {
      registrations?.forEach((registration) => {
        if (registration.scope.includes('/')) {
          registration?.unregister();
        }
      });
    });
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Shell />);
